import { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import * as tracking from 'dibs-tracking';

import { Breadcrumbs } from 'dibs-elements/exports/Breadcrumbs';
import { FormattedMessage } from 'dibs-react-intl';

import { updateUriRef } from '../../actions/filterActions';
import { getAppliedFilter } from '../SbSharedRefineMenu/sbSharedRefineMenuHelpers';

// constants
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
import { VERTICALS as VERTICALS_MAP } from '../../constants/uriConstants';

// some breadcrumbs are not search / browse pages, but special landing pages instead :
const specialCaseLinks = [
    'creators',
    'collections',
    'designs',
    'seller-directory',
    'infogallery',
    'contemporary',
    // home page
    '',
];

const backToItemDefaultMessage = (
    <FormattedMessage id="SbSharedPageBreadcrumbs.backToItem" defaultMessage="< Back To Item" />
);

const testSpecialCase = path => {
    const segments = path.split('/').filter(Boolean);
    const verticalsList = Object.values(VERTICALS_MAP);
    // check for /creators/{vertical}/
    const isCreatorsVertical =
        segments.length === 2 && segments[0] === 'creators' && verticalsList.includes(segments[1]);
    return specialCaseLinks.includes(path.replace(/\//g, '')) || isCreatorsVertical;
};

class SbSharedPageBreadcrumbsComponent extends Component {
    constructor(props) {
        super(props);
        this.updateRoute = this.updateRoute.bind(this);
        this.fireTracking = this.fireTracking.bind(this);
    }

    updateRoute(e) {
        const path = e.target.pathname;
        const shouldUpdateRoute =
            !testSpecialCase(path) &&
            // more from seller links directly back to PDP and shouldn't be
            // caught by SB router
            !this.isMoreFromSeller();

        if (shouldUpdateRoute) {
            e.preventDefault();
            this.fireTracking(e);
            if (this.props.updateUriRef) {
                this.props.updateUriRef({ uriRef: path });
            }
        }
    }

    fireTracking(e) {
        const breadcrumbs = get(this.props, 'itemSearch.breadcrumbs');
        const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
        const currentCategoryName = get(lastBreadcrumb, 'displayName');

        tracking.trackEvent({
            category: 'navigation',
            action: 'breadcrumb click',
            label: `${currentCategoryName}|${e.target.text}`,
        });
    }

    isMoreFromSeller() {
        const pageType = get(this.props, 'itemSearch.pageType');
        return pageType === pageTypes.MORE_FROM_SELLER;
    }

    getItemPk() {
        const appliedFilters = get(this.props, 'itemSearch.appliedFilters');
        const itemPkFilter = getAppliedFilter(appliedFilters, 'itemPk');

        return get(itemPkFilter, 'values[0].urlLabel');
    }

    render() {
        let breadcrumbs = get(this.props, 'itemSearch.breadcrumbs');
        const isMoreFromSeller = this.isMoreFromSeller();
        const itemPk = this.getItemPk();

        if (isMoreFromSeller && itemPk) {
            breadcrumbs = [
                {
                    displayName: backToItemDefaultMessage,
                    path: `/id-${itemPk}`,
                },
            ];
        }

        return (
            <Breadcrumbs
                breadcrumbs={breadcrumbs}
                onClick={this.updateRoute}
                isLastItemActive={isMoreFromSeller}
            />
        );
    }
}

SbSharedPageBreadcrumbsComponent.propTypes = {
    itemSearch: PropTypes.object,
    updateUriRef: PropTypes.func,
};

SbSharedPageBreadcrumbsComponent = connect(null, { updateUriRef })(
    SbSharedPageBreadcrumbsComponent
);

export const SbSharedPageBreadcrumbs = createFragmentContainer(SbSharedPageBreadcrumbsComponent, {
    itemSearch: graphql`
        fragment SbSharedPageBreadcrumbs_itemSearch on ItemSearchQueryConnection {
            pageType
            appliedFilters {
                name
                values {
                    urlLabel
                }
            }
            breadcrumbs {
                displayName
                path
            }
        }
    `,
});
